/**
 * API Helper
 *
 * The methods in this file are mostly in charge of providing an identifier-based interface for the
 * various TBS APIs (which are id based)
 */

import { getSolutionById, getReviews} from '../modules/apiWrapper.js';
import {lookup} from 'ereader-core/dist/utils.main.js';
import {Promise} from 'ereader-core/dist/utils.Promise.js';
import {getInState as _getInState} from './composeReducer.js';

const connected_stores = {};

function guid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return s4() + '-' + s4() + '-' + s4() + '-' + s4();
}

function getState(){}

function getInState(id, map, def){
    let get_state = lookup(connected_stores,`${id}.store.getState`, getState);
    return _getInState(get_state, map, def);
}

function testLoad(id){
    if (getInState(id,'model.model_loaded')) {
        connected_stores[id].promise.resolve();
        connected_stores[id].loaded = true;
    }
}


export function connectStore(store, id){
    if (!id) {
        id = guid();
    }
    const conf = {
        store,
        promise : new Promise,
        loaded : false
    };

    connected_stores[id] = conf;

    conf.unsubscribe = store.subscribe(function(){
        if (conf.loaded) return;
        testLoad(id);
    });

    testLoad(id);

    return id;
}

export function disconnectStore(id){
    connected_stores[id] && connected_stores[id].unsubscribe();
    delete connected_stores[id];
}

export function setUseId(id, flag){
    connected_stores[id].use_id =  flag;
}

/**
 * Get an identifier for a problem
 *
 * @param chapter
 * @param problem
 * @returns {string}
 */
export function getIdentifier(id, chapter, problem){
    let chapter_identifier, problem_identifier;

    if (connected_stores[id].use_id) {
        chapter_identifier = chapter.id || chapter.chapterName;
        problem_identifier = problem.id || problem.problemName;
    } else {
        chapter_identifier = chapter && chapter.chapterName ? chapter.chapterName.replace(/\./g, '-') : '1';
        problem_identifier = problem && problem.problemName ? problem.problemName.replace(/\./g, '-') : '1';
    }

    return `${chapter_identifier.toLowerCase()}-${problem_identifier.toLowerCase()}`;
}

export function parseIdentifier(identifier) {
    const split = identifier.split('-');

    let problem = split.pop();
    let chapter = split.join('.');

    return {
        chapter,
        problem
    };
}

/**
 * Get a problem object
 * @param string identifier
 * @returns promise
 */
export function getProblemByIdentifier(store_id, identifier){
    return connected_stores[store_id].promise.then(function(){
        let state = getInState(store_id,'toc');
        let logger = getInState(store_id,'helpers.logger');

        identifier = identifier.toLowerCase();

        let problem = lookup(state,'problems.'+identifier);
        let problems = state.problem_stack;

        if (!problem) {
            throw {status:404, reason:"no problem"};
        }
        let chapter = lookup(state,'chapters.'+problem.chapter);
        problem = {
            ...problem,
            chapter :{
                ...chapter,
                problems : null
            },
            link : problem.link,
            html : problem.problemHtml,
            next_problem : getSibling(problem.index+1),
            prev_problem : getSibling(problem.index-1)
        };

        return problem;

        function getSibling(index){
            let problem = problems[index];
            if (!problem) return;

            return {
                name : problem.problemName,
                id : problem.problemId,
                chapter : {
                    name: state.chapters[problem.chapter].chapterName,
                    id: state.chapters[problem.chapter].chapterId
                }
            };
        }
    });
}

/**
 * Get a solution
 *
 * @param string identifier
 * @returns promise
 */
export function getSolutionsByIdentifier(store_id, identifier, partner){
    return connected_stores[store_id].promise.then(function(){
        let state = getInState(store_id,'toc');
        let appState = getInState(store_id,'app');
        let logger = getInState(store_id, 'helpers.logger');
        let model = getInState(store_id, 'model');
        let options = getInState(store_id, 'options');

        return getSolutionById(
            lookup(model,'isbn13'),
            lookup(state,`problems.${identifier}.problemId`),
            identifier,
            partner,
            lookup(appState,'user_id'),
            lookup(options,'do_account_sharing'),
            logger,
            lookup(options, 'user.isModerator'),
            lookup(state,`problems.${identifier}.chapter`),
        );
    });
}

/**
 * get the first problem with solutions of a chapter. If no chapter is provided,
 * return the first problem with solutions of the book.
 *
 * @param string [chapter_name]
 * @returns promise
 */
export function getFirstProblem(store_id, chapter_name){
    return connected_stores[store_id].promise.then(function(){
        let chapters = getInState(store_id, 'toc.chapter_stack'),
            chapter;

        if (!chapter_name) {
            for (let i = 0; chapter = chapters[i]; i++) {
                if (chapter.problems.length) break;
            }
        } else {
            chapter = findChapterByName(chapter_name, chapters);
        }

        return getIdentifier(store_id, chapter, chapter.problems[0]);
    });

    function findChapterByName(name, chapters){
        const id_field = connected_stores[store_id].use_id ? 'id' : 'name';
        name = ""+name;

        for (let i=0, chapter; chapter=chapters[i]; i++) {
            if ((""+((id_field === 'id') ? chapter.chapterId : chapter.chapterName)).toLowerCase() == name.toLowerCase()) {
                return chapter;
            } 
        }
    }
}

/**
 * Set the connected_stores[store_id].promise for the various helper functions.
 * Used for testing
 * @param p
 */
export function setPromise(id, p){
    connected_stores[id].promise = p;
}



// WEBPACK FOOTER //
// ./src/helpers/api.js